import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { MDBIcon, MDBModal, MDBContainer, MDBRow, MDBCol } from 'mdbreact';

const MovieDetails = forwardRef(({imageURL, IMDbRating, title, runtime, year, director, cast, sinopse, trailer}, ref) => { 
  
    const [modal, setModal] = useState(false);
    
    const toggleModal= () => {
        modal === false ? setModal(true) : setModal(false);
    }
      useImperativeHandle(ref, () => ({
        toggleModalRef() {
            toggleModal();
        }
    
      }));

      return (
        <>
           <MDBModal isOpen={modal} toggle={toggleModal} size="xl" position="top" >
               <MDBContainer style={{padding: "20px 30px", borderRadius: "20px"}}>
                 <MDBRow>
                     <MDBCol sm={'12'} lg={''}>
                        <div className="text-right">
                          <button className="btn yellow darken-3 white-text p-2" onClick={toggleModal} style={
                            {
                            borderRadius: "20px", 
                            width: "40px", 
                            height: "40px",
                            marginTop: "-50px", 
                            marginRight:"-50px"
                          }
                          }>
                           <MDBIcon icon="times" size="2x"/>
                         </button>
                     </div>
                     </MDBCol>
                   </MDBRow>
                   <MDBRow style={{marginTop: "-30px"}}>
                       <MDBCol xs={'12'} className="ml-3 mb-3">
                         <h1 className="display-5 font-weight-bold deep-orange-text text-lg-left text-center mb-0">{title}</h1>
                         <h5 className="brown-text text-lg-left text-center mb-3">{director}</h5>
                       </MDBCol>
                   </MDBRow>
                   <MDBRow>
                       <MDBCol xs={'12'} lg={'9'} top>
                           <MDBRow className="yellow lighten-4 p-3 mb-3 ml-0 py-3 modal__border-radius">
                             <MDBCol xs={'12'}>
                                 <h4 className="font-weight-bold orange-text text-lg-left mb-0 mr-0">Cast</h4>
                                 <p className="text-monospace">{cast}</p>
                                 <h4 className="font-weight-bold orange-text text-lg-left mb-0">Plot</h4>
                                 <p className="movie__sinopse text-monospace">{sinopse}</p>
                             </MDBCol>  
                           </MDBRow>
                           <MDBRow className="text-center yellow lighten-4 p-2 mb-3 ml-0 py-3 flex-center modal__border-radius">
                               <MDBCol xs={'12'} md={'4'}>
                                 <h5 className="font-weight-bold orange-text">IMDB Rating</h5>
                                 <p className="movie__sinopse text-monospace">{IMDbRating}</p>
                               </MDBCol>
                               <MDBCol xs={'12'} md={'4'}>
                                 <h5 className="font-weight-bold orange-text">Year</h5>
                                 <p className="movie__sinopse text-monospace">{year}</p>
                               </MDBCol>
                               <MDBCol xs={'12'} md={'4'}>
                                 <h5 className="font-weight-bold orange-text">Runtime</h5>
                                 <p className="movie__sinopse text-monospace">{`${runtime} min`}</p>
                               </MDBCol>
                           </MDBRow>
                       </MDBCol>
                       <MDBCol xs={'12'} lg={'3'} middle>
                         <div className="text-center text-lg-right">
                           <img className="modal__img z-depth-2" src={imageURL} alt=""/>
                         </div> 
                       </MDBCol>
                       <MDBCol sm={'12'} top className="mt-2">
                           <h4 className="font-weight-bold orange-text text-lg-left">Trailer</h4>
                           <div className="embed-responsive embed-responsive-16by9 z-depth-1">
                             <iframe src={trailer} title="trailer" allowFullScreen className="embed-responsive-item" ></iframe>
                           </div> 
                       </MDBCol>
                   </MDBRow>
               </MDBContainer>
           </MDBModal>
        </>
         
      )

     
});

export default MovieDetails;